export function deleteButtonsRequest(selector) {
  document.querySelectorAll(selector).forEach((element) => {
    if (element) element.remove()
  })
}
